import { FetchingState } from "rd-redux-http";
import { AppState, CampaignInfo } from "@store";
import { formatDate } from "@common";

export interface ReportCampaignListItem {
    campaignId: string;
    name: string;
    startDate: string;
    endDate: string;
    unit: string;
    country: string;
    timezone: string;
    status: string;
    budget: number;
    currency: string;
}

export function reportCampaignListSelector(appState: AppState): ReportCampaignListItem[] {
    return FetchingState.getDataOrDefault(appState.campaignList.campaigns, [])
        .filter(c => c.status !== "draft" && c.status !== "pending" && c.status !== "archived")
        .map<ReportCampaignListItem>(c => ({
            campaignId: c.campaignId,
            name: c.campaignName,
            startDate: c.startDate,
            endDate: c.endDate,
            unit: c.priceModel,
            country: c.country,
            timezone: c.timezone,
            status: c.status,
            budget: c.budget,
            currency: c.currency
        }))
        .sort((a, b) => (a.name === b.name ? 0 : a.name > b.name ? 1 : -1));
}

export function selectCampaignById(state: AppState, campaignId: string): CampaignInfo | null {
    return state.campaignList.campaigns.fetchState === FetchingState.SUCCESS
        ? state.campaignList.campaigns.data.find(e => e.campaignId == campaignId)
        : null;
}

export function campaignDateRangeSelector(
    campaign: ReportCampaignListItem | undefined,
    dateRange: "last-week" | "last-month" | "overall",
    now = new Date()
): { fromDate: string; toDate: string } {
    now = now || new Date();
    const endDate = campaign ? (new Date(campaign.endDate) < now ? new Date(campaign.endDate) : now) : now;

    switch (dateRange) {
        case "overall":
            if (campaign)
                return {
                    fromDate: formatDate(campaign.startDate),
                    toDate: formatDate(campaign.endDate)
                };

            break;

        case "last-week": {
            return {
                fromDate: formatDate(new Date(endDate).setDate(endDate.getDate() - 7)),
                toDate: formatDate(endDate)
            };
        }

        case "last-month": {
            return {
                fromDate: formatDate(new Date(endDate).setMonth(endDate.getMonth() - 1)),
                toDate: formatDate(endDate)
            };
        }
    }

    return { fromDate: "", toDate: "" };
}
